export default __webpack_public_path__ + "static/media/nextcloud.208884e6.svg";